/**
 * Score ladder (higher = more access, cumulative):
 *   1 = View  →  2 = Comment  →  3 = Edit  →  4 = Full Access
 */
export const PERMISSION_SCORE = {
  VIEW: 1,
  COMMENT: 2,
  EDIT: 3,
  FULL_ACCESS: 4,
} as const;

export type PermissionScore =
  (typeof PERMISSION_SCORE)[keyof typeof PERMISSION_SCORE];
